import { render, staticRenderFns } from "./verify-token.vue?vue&type=template&id=38d76b82&"
import script from "./verify-token.vue?vue&type=script&lang=js&"
export * from "./verify-token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports